import React from "react";
import {Alert, Card, Spinner} from "react-bootstrap";
import HelpTooltip from "../HelpTooltip.jsx";

/**
 * Rahmen für die Auswertungs-Kacheln der Vertriebsauswertung - bewusst
 * NICHT der ChartCard-Baustein der Verkaufsstatistik, weil der bei leerem
 * Ergebnis einen Hinweistext zeigt. Hier verschwindet ein leerer Baustein
 * vollständig (kein Rahmen, keine Überschrift, kein Platzhaltertext), wie
 * für die Vertriebsauswertung vorgegeben. Ladezustand und Fehler werden
 * weiterhin angezeigt, weil sie keine "leeren" Zustände im Sinne der Vorgabe
 * sind, sondern Rückmeldungen über einen laufenden bzw. gescheiterten Abruf.
 */
export default function AnalysisCard({title, help, loading = false, error = null, empty = false, height = 240, actions = null, className = "", children}) {
    if (!loading && !error && empty) {
        return null;
    }

    return (
        <Card className={`shadow-sm ${className}`}>
            <Card.Header className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <span className="d-inline-flex align-items-center gap-1 fw-semibold">
                    {title}
                    {help && (
                        <HelpTooltip placement="right" size={0.8}>
                            {help}
                        </HelpTooltip>
                    )}
                </span>
                {actions}
            </Card.Header>
            <Card.Body>
                {error && <Alert variant="danger" className="mb-0">{error}</Alert>}
                {!error && loading && (
                    <div className="d-flex align-items-center justify-content-center" style={{height}}>
                        <Spinner animation="border" role="status" size="sm">
                            <span className="visually-hidden">Wird geladen…</span>
                        </Spinner>
                    </div>
                )}
                {!error && !loading && children}
            </Card.Body>
        </Card>
    );
}
